
import { DocumentTextIcon, DocumentArrowUpIcon } from "@heroicons/react/24/outline";

const CvImportSelection = ({ onSelectManual, onSelectImport }) => {
    return (
        <div className="flex flex-col items-center justify-center space-y-8 mt-12 py-12">
            <div className="text-center max-w-2xl">
                <h2 className="text-3xl font-heading font-bold text-white mb-4">
                    Comment souhaitez-vous créer ce CV ?
                </h2>
                <p className="text-slate-400">
                    Vous pouvez remplir les informations manuellement via notre assistant, ou gagner du temps en 
                    important un CV existant qui sera automatiquement analysé par notre IA.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl px-4">
                <button
                    onClick={onSelectManual}
                    className="flex flex-col items-center text-center p-8 bg-white/5 border border-white/10 rounded-2xl hover:bg-white/10 hover:border-lenvia-blue/50 transition-all duration-300 group"
                >
                    <div className="w-16 h-16 rounded-full bg-lenvia-blue/10 flex items-center justify-center text-lenvia-blue mb-6 group-hover:scale-110 transition-transform">
                        <DocumentTextIcon className="w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">Création manuelle</h3>
                    <p className="text-sm text-slate-400">
                        Remplissez chaque section étape par étape pour construire le profil du candidat.
                    </p>
                </button>

                <button
                    onClick={onSelectImport}
                    className="flex flex-col items-center text-center p-8 bg-gradient-to-br from-white/5 to-white/5 border border-white/10 rounded-2xl hover:border-emerald-500/50 hover:shadow-[0_0_30px_rgba(16,185,129,0.15)] transition-all duration-300 group relative overflow-hidden"
                >
                    <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    <div className="w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center text-emerald-500 mb-6 group-hover:scale-110 transition-transform relative z-10">
                        <DocumentArrowUpIcon className="w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 relative z-10">Importer un CV</h3>
                    <p className="text-sm text-slate-400 relative z-10">
                        Uploadez un PDF ou DOCX. L'IA extraira automatiquement toutes les compétences et expériences.
                    </p>
                    <div className="mt-4 px-3 py-1 bg-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-wider rounded-full relative z-10">
                        Recommandé
                    </div>
                </button>
            </div>
        </div>
    );
};

export default CvImportSelection;
